import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { clearSchema } from '@api/schemaConfig';

import { IClearSchemaDTO } from '@interfaces/cmModule/schemaConfig';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import {
	MAVENIR_SCHEMA_CONFIG,
	SCHEMA_CONFIG_CLEAR,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface ISchemaDeleteDeleteReturnType {
	clearSchemaConfig: (data: IClearSchemaDTO) => void;
	isLoadingClearSchemaConfig: boolean;
}

export function useMutateSchemaClear(
	props?: IOnSuccess,
): ISchemaDeleteDeleteReturnType {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const { onSuccess } = props || {};

	const {
		mutate: clearSchemaConfig,
		isLoading: isLoadingClearSchemaConfig,
	} = useMutation<IClearSchemaDTO>({
		mutationKey: [SCHEMA_CONFIG_CLEAR],
		mutationFn: clearSchema,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleAdmin,
			EUserRoles.networkOperatorCmModuleEditor,
		],
		onSuccess: () => {
			if (onSuccess) onSuccess();

			dispatch(setSnackbar({
				message: responseMessages.clearDataModelConfig,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG])];
		},
	});

	return {
		clearSchemaConfig,
		isLoadingClearSchemaConfig,
	};
}
